<template>
  <div class="qyjs_box">

   <div>
	 <router-view></router-view>
   </div>
    <div class="box">
		
		<div class="myOne">
			<div class="my-div">
				<div class="title" style="font-size: 20px;">用户服务协议</div>
				<p>本应用非常重视用户隐私政策并严格遵守相关的法律规定。请您仔细阅读《隐私政策》后再继续使用。如果您继续使用我们的服务，表示您已经充分阅读和理解我们协议的全部内容。</p>
				<p>本小程序尊重并保护所有使用服务用户的个人隐私权。</p>
				<p>为了给您提供更准确、更优质的服务，本应用会按照本隐私权政策的规定使用和披露您的个人信息。
					除本隐私权政策另有规定外，在未征得您事先许可的情况下，本应用不会将这些信息对外披露或向第三方提供。本应用会不时更新本隐私权政策。</p>
				<p> 您在同意本应用服务使用协议之时，即视为您已经同意本隐私权政策全部内容。 </p>
				<div class="title">1.适用范围</div>
				<p>(a)在您注册本应用小程序帐号时，您根据小程序要求提供的个人注册信息。</p>
				<p>(b)在您使用本应用网络服务，或访问本应用平台网页时，本应用自动接收并记录的您的浏览器和计算机上的信息，包括但不限于您的IP地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录等数据。
				</p>
				<p>(c)本应用通过合法途径从商业伙伴处取得的用户个人数据。</p>
				<p>(d)本应用严禁用户发布不良信息，如裸露、色情和亵渎内容，发布的内容我们会进行审核，一经发现不良信息，会禁用该用户的所有权限，予以封号处理。</p>
				<div class="title">2.信息使用</div>
				<p>(a)本应用不会向任何无关第三方提供、出售、出租、分享或交易您的个人登录信息。如果我们存储发生维修或升级，我们会事先发出推送消息来通知您，请您提前允许本应用消息通知。</p>
				<p>(b)本应用亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何本应用平台用户如从事上述活动，一经发现，本应用有权立即终止与该用户的服务协议。包括但不限于您的IP地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录等数据。
				</p>
				<p>(c)为服务用户的目的，本应用可能通过使用您的个人信息，向您提供您感兴趣的信息，包括但不限于向您发出产品和服务信息，或者与本应用合作伙伴共享信息以便他们向您发送有关其产品和服务的信息。（后者需要您的事先同意）
				</p>
				<div class="title">3.信息披露</div>
				<p>在如下情况下，本应用将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：</p>
				<p>(a)未经您事先同意，我们不会向第三方披露。</p>
				<p>(b)为提供您所要求的产品和服务，而必须和第三方分享您的个人信息。</p>
				<p>(c)根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露。</p>
				<p>(d)如您出现违反中国有关法律、法规或者本应用服务协议或相关规则的情况，需要向第三方披露。</p>
				<p>(e)如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷</p>
				<div class="title">4.信息存储和交换</div>
				<p>本应用收集的有关您的信息和资料将保存在本应用及（或）其关联公司的服务器上，这些信息和资料可能传送至您所在国家、地区或本应用收集信息和资料所在地的境外并在境外被访问、存储和展示。</p>
				<div class="title">5.Cookie的使用</div>
				<p>(a)在您未拒绝接受cookies的情况下，本应用会在您的计算机上设定或取用cookies，以便您能登录或使用依赖于cookies的本应用平台服务或功能。本应用使用cookies可为您提供更加周到的个性化服务，包括推广服务。
				</p>
				<p>(b)您有权选择接受或拒绝接受cookies。您可以通过修改浏览器设置的方式拒绝接受cookies。但如果您选择拒绝接受cookies，则您可能无法登录或使用依赖于cookies的本应用网络服务或功能。
				</p>
				<p>(c)通过本应用所设cookies所取得的有关信息，将适用本政策。</p>
				<div class="title">6.本隐私政策的更改</div>
				<p>(a)如果决定更改隐私政策，我们会在本政策中、本公司网站中以及我们认为适当的位置发布这些更改，以便您了解我们如何收集、使用您的个人信息，哪些人可以访问这些信息，以及在什么情况下我们会透露这些信息。
				</p>
				<p>(b)本公司保留随时修改本政策的权利，因此请经常查看。如对本政策作出重大更改，本公司会通过网站通知的形式告知。</p>
				<p>请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是本应用用户名及密码发生泄露，请您立即联络本应用客服，以便本应用采取相应措施。</p>
				<p>感谢您花时间了解我们的隐私政策！我们将尽全力保护您的个人信息和合法权益，再次感谢您的信任！</p>
			</div>
		</div>
		
		
	</div>
	<div ref="loadMoreTrigger" style="height: 100px;"></div>
    
  </div>
</template>

<script>
import { xuemengintro } from "@/api/intoxuemeng";
	import  {UPLODE_URL} from '@/utils/request'
	import { EventBus } from '@/utils/event-bus.js';
export default {
  data() {
    return {
		UPLODE_URL,
		batchName:'',
      filtrate: {
      	A: [],//nianfen 
      	B: ['公办', '民办', '独立学院', '中外合作办学', '内地与港澳台地区合作办学', '境外高校独立办学'],//办学性质
      	C: ['985', '211', '研究生院', '双一流', '保研', '双高高职', '示范高职', '骨干高职'],//院校层次
      	D: [],//标签
      	E: [{ id: 1, name: '冲', num: 0 }, { id: 2, name: '稳', num: 0 }, { id: 3, name: '保', num: 0 }, { id: 4, name: '新增' }],
		F:[],
		G: ['是'],
		H: [{name:'101计划',id:'是',quer:'oneJihuas'},{name:'卓越工程师',id:'是',quer:'zuoyueJihuas'},{name:'国优计划',id:'是',quer:'youJihuas'}],
		// {name:'武书连',id:'是',quer:'wushulian'},
		J: [{name:'软科综合',id:'是',quer:'ruanke'},{name:'校友会综合',id:'是',quer:'xiaoyouhui'},{name:'QS',id:'是',quer:'QS'},{name:'US',id:'是',quer:'US'}],
      },
	  schList:[],
	  pageTotal:0,
	  busy: true,

	  // 查询参数
	  queryParams: {
	  	pageNum: 1,
	  	pageSize: 10,
		
	  	schoolName: '',//学校名
	  	schoolLevel:'',//本科和专科
	  	citySchoolIds: [],//省份id 下拉选择传
	  	majorCodeAlls: [],// //专业id 下拉选择传
	  	// majorNames: '', //专业名
	  	schoolType: '', //院校类型
	  	natureName: [], //办学性质
	  	attribute: [], //院校层次
	  	notTtile: [] ,//标签
	  	schoolCityOne:[],
	  	
	  	oneJihuas:'',
	  	zuoyueJihuas:'',
	  	youJihuas:'',
	  	
	  	ruanke:'',
	  	xiaoyouhui:'',
	  	// wushulian:'',
	  	qs:'',
	  	us:'',
		
		
		
	  },
	  navData:[],
	  navDataIndex:0,
	  
	  courseTypeId:'',
	  name:'',
	  token: localStorage.getItem('token')||'',
	  user:JSON.parse(localStorage.getItem('user'))||'',
	  pageNum: 1,
	  
	  isSticky: false,
	  stickyOffset: 20,
    };
  },
  directives: {
      intersect: {
        bind(el, binding) {
          const observer = new IntersectionObserver((entries, observer) => {
			  console.log('entries',entries)
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                const img = entry.target;
				console.log('2222sdfsfs',img)
                // 在这里可以做图片的懒加载处理，比如更改src属性
                // img.src = img.dataset.src;
                // 或者触发其他的方法
                // binding.value(entry, observer);
                // observer.unobserve(img); // 停止观察
				// this.createObserver();
              }
            });
          });
   
          observer.observe(el);
        }
      }
    },
  created() {
	// this.getList() //列表数据
	this.courseTypeId = this.$route.query.id
	this.name = this.$route.query.name
	this.getType()
	
  },
  mounted() {
  	 
	 // console.log('this.$route.query',this.$route.query)
	 // this.courseTypeId = this.$route.query.id
	 // this.name = this.$route.query.name
	 // this.getType()
	 this.token= localStorage.getItem('token')||''
	 this.user=JSON.parse(localStorage.getItem('user'))||''
	 this.createObserver();
	 window.addEventListener('scroll', this.handleScroll);
	 // 监听退出登录事件
	 // window.addEventListener('storage', this.handleLogout);
  },
  
  beforeRouteEnter(to, from, next) {
    next(vm => {
      console.log(vm.$route.query); // 正确使用 vm 访问组件实例
	  vm.courseTypeId = vm.$route.query.id
	  vm.name = vm.$route.query.name
	  vm.getType()
    });
  },
 beforeDestroy() {
 	  window.removeEventListener('scroll', this.handleScroll);
	  // 监听退出登录事件
	  // window.addEventListener('storage', this.handleLogout);
   },
  methods: {
	
	  handleScroll() {
	        this.isSticky = window.scrollY >= this.stickyOffset;
	  			console.log('this.isSticky',this.isSticky)
	    },
	  getType(){
		  let qu={
			  courseTypeId:this.courseTypeId
		  }
		this.api.courseTypeListOneApi(qu).then(res => {
			this.navData = res.data
			 this.navDataIndex = res.data[0].id
			this.getList()
		})
	  },
	  navClick(item){
	  		this.navDataIndex=item.id
			this.getList()
	  		this.$forceUpdate()
	  },
	  // 跳转学校详情
	  goInfo(item){
		  if(this.user.userVip==0){
			  EventBus.$emit('vipOpen');
			  return
		  }
		 localStorage.setItem('videoInfo',JSON.stringify(item))
		  this.$router.push({path:'/Ainformation/videoInfo'})
		  return
		  
		const route =this.$router.resolve({name:'videoInfo',})
		localStorage.setItem('videoInfo',JSON.stringify(item))
		// 打开新窗口并导航至生成的URL
		window.open(route.href, '_blank');
	  },
	  handleIntersect(entry, observer){
		  console.log('11111111111111111111fff')
		  if (this.pageNum >= this.pageTotal ) {
		  	// this.$message({
		  	//   message: '没有更多了',
		  	//   type: 'warning',
		  	//   duration: '4000'
		  	// });
		  	return
		  }
		  // this.busy = true
		  this.pageNum++;
		  this.getList('more')
	  },
	  createObserver() {
	        const options = {
	          root: null, // viewport
	          rootMargin: '100px',
	          threshold: 1.0
	        };
	        const observer = new IntersectionObserver(this.handleIntersect, options);
	        observer.observe(this.$refs.loadMoreTrigger);
	      },
	  creat(){
		  
	  },
	  
	   
	   
	   // 数据列表请求
	   getList(type){
		   let qu={
		   		courseTypeId:this.courseTypeId,
				pageNum: this.pageNum,
				pageSize: 10,
				pid: this.navDataIndex,
		   }
		    this.api.courseListApi(qu).then(res => {
				if(res.code==200){
					
					if (type == 'more') {
						if (!res.data) {
							this.$message({
								message: '没有更多了',
								type: 'warning',
								duration: '4000'
							});
							return
						}
						this.schList = [...this.schList, ...res.data.rows];
						
					}else{
						this.schList = []
						this.schList = res.data ? res.data.rows : [];
						// this.dataText = res.data ? '' : '暂无数据'; //进去页面先让字样为空
						this.pageTotal = res.data ? res.data.pageTotal : 0;
					}
					
					
					// if(res.data&&res.data.rows){
					// 	this.pageTotal = res.data.pageTotal
					// 	this.schList = res.data.rows;
						
					// 	// this.schList = [...this.schList, ...res.data.rows];
						
					// }else{
					// 	this.schList = []
					// }
				}else{
					 this.$message.error(res.msg);
				}
			})
	   }
  },
};
</script>

<style lang="scss" scoped>
.myOne {
		width: 100%;
		background-color: #fff;
		display: flex;
		justify-content: center;
		font-size: 14px;
	}

	.my-div {
		width: 90%;
		margin: auto;
		text-indent: 24rpx;
		padding-top: 10px;
		p{
			text-align: justify;
			margin-top: 5px;
		}
		.title{
			font-weight: bold;
			padding: 5px 0;
		}
	}

</style>